import { normalize } from 'normalizr'
import { category } from '../adapters/categorySchema'
import { organization } from '../adapters/organizationSchema'
import { rate } from '../adapters/rateSchema'
import * as ActionTypes from './actionTypes'

// categories actions
export const b_fetchCategoriesSuccess = data => ({
    type: ActionTypes.B_CATEGORIES_FETCH_SUCCESS,
    ...data
})

export const b_fetchCategoriesFailure = error => ({
    type: ActionTypes.B_CATEGORIES_FETCH_FAILURE,
    error
})

export const b_saveCategoriesSuccess = data => ({
    type: ActionTypes.B_CATEGORIES_SAVE_SUCCESS,
    data: normalize(data, category)
})

export const b_saveCategoriesFailure = error => ({
    type: ActionTypes.B_CATEGORIES_SAVE_FAILURE,
    error
})

export const b_deleteCategorySuccess = id => ({
    type: ActionTypes.B_CATEGORIES_DELETE_SUCCESS,
    data: id
})

export const b_deleteCategoryFailure = error => ({
    type: ActionTypes.B_CATEGORIES_DELETE_FAILURE,
    error
})

export const b_importCategoriesSuccess = data => ({
    type: ActionTypes.B_CATEGORIES_IMPORT_SUCCESS,
    ...data
})

export const b_importCategoriesFailure = error => ({
    type: ActionTypes.B_CATEGORIES_IMPORT_FAILURE,
    error
})

// organizations actions
export const b_fetchOrganizationsSuccess = data => ({
    type: ActionTypes.B_ORGANIZATIONS_FETCH_SUCCESS,
    ...data
})

export const b_fetchOrganizationsFailure = error => ({
    type: ActionTypes.B_ORGANIZATIONS_FETCH_FAILURE,
    error
})

export const b_saveOrganizationsSuccess = data => ({
    type: ActionTypes.B_ORGANIZATIONS_SAVE_SUCCESS,
    data: normalize(data, organization)
})

export const b_updateOrganizationsFailure = error => ({
    type: ActionTypes.B_ORGANIZATIONS_UPDATE_FAILURE,
    error
})

export const b_updateOrganizationsSuccess = data => ({
    type: ActionTypes.B_ORGANIZATIONS_UPDATE_SUCCESS,
    data: normalize(data, organization)
})

export const b_deleteOrganizationSuccess = id => ({
    type: ActionTypes.B_ORGANIZATIONS_DELETE_SUCCESS,
    data: id
})

export const b_deleteOrganizationFailure = error => ({
    type: ActionTypes.B_ORGANIZATIONS_DELETE_FAILURE,
    error
})

export const b_saveOrganizationsFailure = error => ({
    type: ActionTypes.B_ORGANIZATIONS_SAVE_FAILURE,
    error
})

// rates actions
export const b_fetchRatesSuccess = data => ({
    type: ActionTypes.B_RATES_FETCH_SUCCESS,
    ...data
})

export const b_fetchRatesFailure = error => ({
    type: ActionTypes.B_RATES_FETCH_FAILURE,
    error
})

export const b_saveRatesSuccess = data => ({
    type: ActionTypes.B_RATES_SAVE_SUCCESS,
    data: normalize(data, rate)
})

export const b_saveRatesFailure = error => ({
    type: ActionTypes.B_RATES_SAVE_FAILURE,
    error
})

export const b_deleteRateSuccess = id => ({
    type: ActionTypes.B_RATES_DELETE_SUCCESS,
    data: id
})

export const b_deleteRateFailure = error => ({
    type: ActionTypes.B_RATES_DELETE_FAILURE,
    error
})

export const b_importRatesSuccess = data => ({
    type: ActionTypes.B_RATES_IMPORT_SUCCESS,
    ...data
})

export const b_importRatesFailure = error => ({
    type: ActionTypes.B_RATES_IMPORT_FAILURE,
    error
})

// currentOrganization actions
export const b_changeCurrentOrganization = id => ({
    type: ActionTypes.B_CURRENT_ORGANIZATION_CHANGE,
    data: id
})

// sync actions
export const b_pushYearPricesRequest = () => ({
    type: ActionTypes.B_PUSH_YEAR_PRICES_REQUEST
})
export const b_pushYearPricesSuccess = () => ({
    type: ActionTypes.B_PUSH_YEAR_PRICES_SUCCESS
})
export const b_pushYearPricesFailure = () => ({
    type: ActionTypes.B_PUSH_YEAR_PRICES_FAILURE
})

export const b_pushYearRestrictionsRequest = () => ({
    type: ActionTypes.B_PUSH_YEAR_RESTRICTIONS_REQUEST
})
export const b_pushYearRestrictionsSuccess = () => ({
    type: ActionTypes.B_PUSH_YEAR_RESTRICTIONS_SUCCESS
})
export const b_pushYearRestrictionsFailure = () => ({
    type: ActionTypes.B_PUSH_YEAR_RESTRICTIONS_FAILURE
})

export const b_inventoryAvailabilityRequest = () => ({
    type: ActionTypes.B_INVENTORY_AVAILABILITY_REQUEST
})
export const b_inventoryAvailabilitySuccess = () => ({
    type: ActionTypes.B_INVENTORY_AVAILABILITY_SUCCESS
})
export const b_inventoryAvailabilityFailure = () => ({
    type: ActionTypes.B_INVENTORY_AVAILABILITY_FAILURE
})

export const b_inventoryOrderRequest = () => ({
    type: ActionTypes.B_INVENTORY_ORDER_REQUEST
})
export const b_inventoryOrderSuccess = () => ({
    type: ActionTypes.B_INVENTORY_ORDER_SUCCESS
})
export const b_inventoryOrderFailure = () => ({
    type: ActionTypes.B_INVENTORY_ORDER_FAILURE
})

export const b_otelmsInventoryRequest = () => ({
    type: ActionTypes.B_INVENTORY_OTELMS_REQUEST
})
export const b_otelmsInventorySuccess = () => ({
    type: ActionTypes.B_INVENTORY_OTELMS_SUCCESS
})
export const b_otelmsInventoryFailure = () => ({
    type: ActionTypes.B_INVENTORY_OTELMS_FAILURE
})

export const b_loadBasedOnReservationSummaryRequest = () => ({
    type: ActionTypes.B_LOAD_BASED_ON_RESERVATION_SUMMARY_REQUEST
})
export const b_loadBasedOnReservationSummarySuccess = () => ({
    type: ActionTypes.B_LOAD_BASED_ON_RESERVATION_SUMMARY_SUCCESS
})
export const b_loadBasedOnReservationSummaryFailure = () => ({
    type: ActionTypes.B_LOAD_BASED_ON_RESERVATION_SUMMARY_FAILURE
})

// easyms
export const b_fetchEasymsCategoriesSuccess = data => ({
    type: ActionTypes.B_EASYMS_CATEGORIES_FETCH_SUCCESS,
    payload: { ...data }
})
export const b_fetchEasymsCategoriesFailure = error => ({
    type: ActionTypes.B_EASYMS_CATEGORIES_FETCH_FAILURE,
    payload: { error }
})
export const b_fetchEasymsRatesSuccess = data => ({
    type: ActionTypes.B_EASYMS_RATES_FETCH_SUCCESS,
    payload: { ...data }
})
export const b_fetchEasymsRatesFailure = error => ({
    type: ActionTypes.B_EASYMS_RATES_FETCH_FAILURE,
    payload: { error }
})



// WEBPACK FOOTER //
// ./src/actions/bookingActions.js